import * as _ from "lodash-es";
import Campus from "../../../../../types/Campus";
import groupCampusesByRegion from "../../../../../util/groupCampusesByRegion";
import {CampusSelectorProps} from "./CampusSelector";
import {
	Menu,
	Section,
	Header,
	ListBoxItem,
	Selection,
} from "react-aria-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLocationDot as faLocationDotSolid} from "@fortawesome/free-solid-svg-icons/faLocationDot";
import {faLocationDot} from "@fortawesome/pro-regular-svg-icons/faLocationDot";

export type SetCurrentCampuses = (campuses: Selection) => void;

interface SectionForRegionProps {
	region: string;
	regionCampuses: Campus[];
	currentCampuses: Set<string>;
}

const SectionForRegion: React.FC<SectionForRegionProps> = ({
	region,
	regionCampuses,
	currentCampuses,
}) => {
	return (
		<Section className="mb-4 flex break-inside-avoid-column flex-col gap-2">
			<Header className="border-b-1 border-gray-600 pb-2 font-overline text-gray-600">
				{region}
			</Header>
			{regionCampuses.map(({campusId, city, comingSoon}) => (
				<ListBoxItem
					className={`flex cursor-pointer items-center gap-2 rounded-full px-4 py-2 transition-colors data-[focused]:bg-navy-200 hover:bg-navy-200 selected:bg-navy-200`}
					key={campusId}
					id={campusId}
					aria-label={city}
				>
					<FontAwesomeIcon
						icon={
							currentCampuses.has(campusId) ? faLocationDotSolid : faLocationDot
						}
					/>
					<span>
						{city} {comingSoon ? "(Coming Soon!)" : ""}
					</span>
				</ListBoxItem>
			))}
		</Section>
	);
};

const CampusSelectorDropdown: React.FC<CampusSelectorProps> = ({
	currentCampuses,
	setCurrentCampuses,
	allCampusesById,
}) => {
	const campusesByRegion = groupCampusesByRegion(allCampusesById);
	return (
		<Menu
			id="campus-selector-menu"
			className="hidden gap-4 border-1 border-gray-400 bg-white p-8 md:block md:max-h-[40rem] md:columns-4"
			selectionMode="single"
			disallowEmptySelection
			selectedKeys={currentCampuses}
			onSelectionChange={setCurrentCampuses}
			autoFocus="first"
			shouldFocusWrap
		>
			{_.map(campusesByRegion, (campusesForRegion, region) => (
				<SectionForRegion
					key={region}
					region={region}
					regionCampuses={campusesForRegion}
					currentCampuses={currentCampuses}
				/>
			))}
		</Menu>
	);
};

export default CampusSelectorDropdown;
